import BaseApi from '../BaseApi';

class DoctorFeedbackApi extends BaseApi {
  protected getSpecificApiPrefix(): string {
    return 'v2/managers/';
  }
}

export default DoctorFeedbackApi;
